import { Directive } from '@angular/core';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { TableListGridProviderDirective } from '@app/components/table-list-grid/directives/table-list-grid-provider.directive';
import {
  ListView,
  ListViewProviderDirective,
  ViewProviderDirective
} from '@ntap/core';
import { map, Observable } from 'rxjs';

@Directive({
  selector: '[appOdabirAgentaProvider]',
  providers: [
    {
      provide: ListViewProviderDirective,
      useExisting: OdabirPovezanogAgentaProviderDirective
    },
    {
      provide: ViewProviderDirective,
      useExisting: OdabirPovezanogAgentaProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: OdabirPovezanogAgentaProviderDirective
    },
    {
      provide: TableListGridProviderDirective,
      useExisting: OdabirPovezanogAgentaProviderDirective
    }
  ],
  inputs: ['viewState', 'viewName']
})
export class OdabirPovezanogAgentaProviderDirective extends TableListGridProviderDirective {
  override get view$(): Observable<ListView> {
    return super.view$.pipe(
      map((view: any) => {
        view.actions = view.actions.filter(
          (a: any) => a.name === 'openAgent' || a.name === 'multiselect'
        );
        return view;
      })
    );
  }
}
